/**
 * Product card color availability:
 * A color is sold-out on cards only when NO size of that color is available.
 * Fixes Globo collection swatches that cross out a color when one size is missing.
 */
(function () {
  'use strict';

  const GLOBO_SOLD_OUT_CLASSES = [
    'globo-sold-out-cross-out',
    'globo-sold-out',
    'soldout',
    'sold-out',
    'is-unavailable',
    'unavailable',
    'outstock',
    'class-sold'
  ];

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getOptionValue(item) {
    return (
      item.getAttribute('data-value') ||
      item.getAttribute('data-option-value') ||
      item.querySelector('[data-value]')?.getAttribute('data-value') ||
      item.querySelector('input')?.value ||
      item.querySelector('label')?.getAttribute('data-value') ||
      item.querySelector('.globo-style--button, .globo-border-color-swatch, a, label, span')?.textContent ||
      item.textContent
    );
  }

  function clearSoldOut(item) {
    GLOBO_SOLD_OUT_CLASSES.forEach((cls) => item.classList.remove(cls));
    item.classList.add('available');
    item.setAttribute('data-613-color-available', 'true');
    item.removeAttribute('aria-disabled');
    item.removeAttribute('disabled');

    item.querySelectorAll('input, button, a, label, span').forEach((el) => {
      el.removeAttribute('disabled');
      el.removeAttribute('aria-disabled');
      GLOBO_SOLD_OUT_CLASSES.forEach((cls) => el.classList.remove(cls));
    });

    item.querySelectorAll('img.crossed-out, .crossed-out').forEach((img) => {
      img.style.display = 'none';
    });
  }

  function markSoldOut(item) {
    item.classList.add('globo-sold-out-cross-out');
    item.classList.remove('available');
    item.removeAttribute('data-613-color-available');
  }

  function parseCardData(card) {
    const script = card.querySelector('[data-613-card-availability]');
    if (!script) return null;
    try {
      const data = JSON.parse(script.textContent);
      const colors = (data.availableColors || []).map(normalize).filter(Boolean);
      return new Set(colors);
    } catch (e) {
      return null;
    }
  }

  function isColorSwatchList(list) {
    if (!list) return false;
    if (list.classList.contains('g-variant-color')) return true;
    if (list.closest('.g-variant-color')) return true;
    return Boolean(
      list.querySelector('.globo-border-color-swatch, [style*="background"], .swatch_color_prd')
    );
  }

  function fixCard(card) {
    const availableColors = parseCardData(card);
    if (!availableColors || !availableColors.size) return;

    const roots = [card];
    const gridItem = card.closest(
      '.grid__item, .product-grid__item, .collection .grid__item, li.grid__item, .card-wrapper'
    );
    if (gridItem && gridItem !== card) roots.push(gridItem);

    roots.forEach((root) => {
      root
        .querySelectorAll(
          '.swatches-globo li, .globo-swatch-list li, .globo-swatch-product-detail li, li.select-option, .product-card-613 .variant_size, ul.colorlist li'
        )
        .forEach((item) => {
          const list = item.closest('.ul-swatches-list, ul.value, ul.colorlist');
          if (list && !isColorSwatchList(list) && !list.classList.contains('colorlist')) {
            if (
              !item.querySelector('[style*="background"], .globo-border-color-swatch') &&
              !/color|צבע|light|black|white|green|cream|ophite/i.test(getOptionValue(item))
            ) {
              return;
            }
          }

          const value = normalize(getOptionValue(item));
          if (!value) return;

          if (availableColors.has(value)) {
            clearSoldOut(item);
          }
        });
    });
  }

  function fixAllCards() {
    document.querySelectorAll('[data-613-product-card]').forEach(fixCard);
  }

  let scheduled = false;
  function scheduleFix() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fixAllCards();
    });
  }

  function init() {
    fixAllCards();

    const root = document.querySelector('#MainContent, .collection, .product-grid, body');
    if (root) {
      const observer = new MutationObserver(scheduleFix);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled']
      });
    }

    [200, 600, 1200, 2500].forEach((ms) => window.setTimeout(fixAllCards, ms));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
